"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEEKDAYS_LIST = exports.AVAILABILITY_OPTIONS = exports.AVAILABLE_DAYS = exports.MAX_CUSTOM_AVAILABILITY_WEEKS = exports.TWO_WEEKS = exports.CUSTOM_AVAILABILITY = exports.DAY_TIME_RANGE = exports.SIXTY_MINUTE_MILLIS = exports.FORTY_FIVE_MINUTE_MILLIS = exports.THIRTY_MINUTE_MILLIS = exports.FIFTEEN_MINUTE_MILLIS = exports.TEN_MINUTE_MILLIS = exports.DAY_DURATION = exports.HOUR_DURATION = exports.THIRTY_MINUTE_DURATION = exports.FIFTEEN_MINUTE_DURATION = exports.ZERO_DURATION = exports.ONE_DAY = exports.ONE_HOUR = exports.MINUTES_TO_MILLIS = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _TimeRange = _interopRequireDefault(require("MeetingsBase/models/TimeRange"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

// durations in milliseconds
var MINUTES_TO_MILLIS = 60 * 1000;
exports.MINUTES_TO_MILLIS = MINUTES_TO_MILLIS;
var ONE_HOUR = 60 * MINUTES_TO_MILLIS;
exports.ONE_HOUR = ONE_HOUR;
var ONE_DAY = 60 * 24 * MINUTES_TO_MILLIS; // Durations

exports.ONE_DAY = ONE_DAY;

var ZERO_DURATION = _I18n.default.moment.duration(0).asMinutes();

exports.ZERO_DURATION = ZERO_DURATION;

var getDurationAsMillis = function getDurationAsMillis(duration) {
  return _I18n.default.moment.duration({
    minutes: duration
  }).asMilliseconds();
};

var getDurationAsMinutes = function getDurationAsMinutes(duration) {
  return _I18n.default.moment.duration({
    minutes: duration
  }).asMinutes();
};

var FIFTEEN_MINUTE_DURATION = getDurationAsMinutes(15);
exports.FIFTEEN_MINUTE_DURATION = FIFTEEN_MINUTE_DURATION;
var THIRTY_MINUTE_DURATION = getDurationAsMinutes(30);
exports.THIRTY_MINUTE_DURATION = THIRTY_MINUTE_DURATION;
var HOUR_DURATION = getDurationAsMinutes(60);
exports.HOUR_DURATION = HOUR_DURATION;

var DAY_DURATION = _I18n.default.moment.duration({
  hours: 24
}).asMinutes();

exports.DAY_DURATION = DAY_DURATION;
var TEN_MINUTE_MILLIS = getDurationAsMillis(10);
exports.TEN_MINUTE_MILLIS = TEN_MINUTE_MILLIS;
var FIFTEEN_MINUTE_MILLIS = getDurationAsMillis(15);
exports.FIFTEEN_MINUTE_MILLIS = FIFTEEN_MINUTE_MILLIS;
var THIRTY_MINUTE_MILLIS = getDurationAsMillis(30);
exports.THIRTY_MINUTE_MILLIS = THIRTY_MINUTE_MILLIS;
var FORTY_FIVE_MINUTE_MILLIS = getDurationAsMillis(45);
exports.FORTY_FIVE_MINUTE_MILLIS = FORTY_FIVE_MINUTE_MILLIS;
var SIXTY_MINUTE_MILLIS = getDurationAsMillis(60);
exports.SIXTY_MINUTE_MILLIS = SIXTY_MINUTE_MILLIS;

var DAY_TIME_RANGE = _TimeRange.default.from({
  start: ZERO_DURATION,
  end: DAY_DURATION
}); // The value to store for weeksToAdvertise when using custom availability.
// (weeksToAdvertise requires an integer value)


exports.DAY_TIME_RANGE = DAY_TIME_RANGE;
var CUSTOM_AVAILABILITY = 0;
exports.CUSTOM_AVAILABILITY = CUSTOM_AVAILABILITY;
var TWO_WEEKS = 2;
exports.TWO_WEEKS = TWO_WEEKS;
var MAX_CUSTOM_AVAILABILITY_WEEKS = 10;
exports.MAX_CUSTOM_AVAILABILITY_WEEKS = MAX_CUSTOM_AVAILABILITY_WEEKS;
var AVAILABLE_DAYS = (0, _keyMirror.default)({
  SUNDAY: null,
  MONDAY: null,
  TUESDAY: null,
  WEDNESDAY: null,
  THURSDAY: null,
  FRIDAY: null,
  SATURDAY: null
});
exports.AVAILABLE_DAYS = AVAILABLE_DAYS;
var AVAILABILITY_OPTIONS = (0, _keyMirror.default)(Object.assign({
  EVERY_DAY: null,
  MON_FRI: null,
  SAT_SUN: null
}, AVAILABLE_DAYS));
exports.AVAILABILITY_OPTIONS = AVAILABILITY_OPTIONS;
var WEEKDAYS_LIST = [AVAILABLE_DAYS.SUNDAY, AVAILABLE_DAYS.MONDAY, AVAILABLE_DAYS.TUESDAY, AVAILABLE_DAYS.WEDNESDAY, AVAILABLE_DAYS.THURSDAY, AVAILABLE_DAYS.FRIDAY, AVAILABLE_DAYS.SATURDAY];
exports.WEEKDAYS_LIST = WEEKDAYS_LIST;